import { useRef } from 'react';
import { v4 } from 'uuid';

export const useUniqueHtmlId = (prefix) => {
  const id = useRef(`${prefix}-${v4()}`);
  return id.current;
};
